import string2regex from './lib/string2regex';

export default string2regex;
